import styled from 'styled-components';
import * as color from 'modules/common/theme/color';

const Empty = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: ${color.TitleBorder};
  font-weight: bold;
  border-radius: 3px;
  background-color: #ffffff;
  padding: 55px 0;
  position: relative;
  cursor: pointer;

  svg {
    fill: ${color.TitleBorder};
  }

  span {
    display: block;
    padding: 5px 0 0 0;
    font-size: 16px;
  }
`;

export default { Empty };
